<template>
  <v-dialog :value="value" width="800" @input.self="$emit('input', $event)">
    <v-card class="suspend-flyer-card">
      <v-card-text>
        <mf-icon size="55" color="vermelho-l20">error</mf-icon>

        <p class="related-campaings-title">Este encarte pertence à(s) seguinte(s) campanha(s) push:</p>

        <div class="list-campaign">
          <div v-for="(campaign, index) in associatedCampaigns" :key="index">
            <p>{{ campaign.name }}</p>
          </div>
        </div>
        <mf-action-buttons
          class="mt-2"
          :primary-button="{
            text: 'Suspender encarte',
            action: suspendFlyer,
            isVisible: true,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: closeDialog,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    associatedCampaigns: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit('input', false)
    },

    suspendFlyer() {
      this.$emit('suspend-flyer')
      this.$emit('input', false)
    },
  },
}
</script>

<style lang="scss">
.suspend-flyer-card {
  padding: 24px 0;
  .v-card__text {
    text-align: center;
    padding: 20px 0 !important;
  }

  .related-campaings-title {
    margin: 16px 0 !important;
    font-size: 16px;
  }

  .list-campaign {
    background-color: $cinza-l90;
    padding: 5px 64px;

    p {
      text-align: left;
      margin-bottom: 0px !important;
    }
  }

  .suspend-actions {
    justify-content: center;

    button {
      margin: 0 20px;
    }
  }
}
</style>
